
import React from 'react'
import { useState} from 'react';
import styled from 'styled-components';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { BackButtonSpan} from '../../../Styles/CommonStyles';
import OemToOrg from './OemToOrg';
import OrgToOem from './OrgToOem';

const Container = styled.div`
width: 100%;
`
const Wrapper = styled.div`
padding: 5px;
display: flex;
flex-direction: column;
`
const AllWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: space-around;
    flex-grow: 1;
    row-gap: 50px;
`
const OptionContainer = styled.div`
    width:350px;
    display: flex;
    height:150px;
    background-color:#fff;
    /* align-items: center;
    justify-content: center; */
    color: #58548E;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2857142857142856rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin-left: 24px;
    font-weight: 700;
    cursor: pointer;
    position: relative;
    transition: box-shadow 0.3s;
    &:hover{
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    }
`
const InnerContainer = styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
`
const FormTabCont = styled.div`
`
const SubtabWrapper = styled.div`
  
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

const AssetTags = () => {
  const [bclick, setBclick] = useState('home');


  const handleOrgToOem = () =>{
    setBclick("orgtooem")
  }

  const handleOemToOrg = () =>{
    setBclick("oemtoorg");
  }
  const genBackHandler = () => {
    setBclick("home");
  }


  return (
    <Container>
      <Wrapper>
        <AllWrapper>
          {bclick === "home" && <OptionContainer onClick={handleOrgToOem}><InnerContainer >ORG tag to OEM tag </InnerContainer></OptionContainer>}
          {bclick === "home" && <OptionContainer onClick={handleOemToOrg}><InnerContainer >OEM tag to ORG tag </InnerContainer></OptionContainer>}
        </AllWrapper>

        <FormTabCont>
          <SubtabWrapper>
            {bclick !== "home" && <BackArrowContainer onClick={genBackHandler}><ArrowLeftIcon /><BackButtonSpan >Back to Asset Tags Home</BackButtonSpan></BackArrowContainer>}
            {bclick === "oemtoorg" && <OemToOrg/>}
            {bclick === "orgtooem" && <OrgToOem/>}
          </SubtabWrapper>
          
        </FormTabCont>
      </Wrapper>
    </Container>
  )
}

export default AssetTags
